<template lang="pug">

.app-card.overflow-x-auto.orderables-styled-panel
  .d-flex(class='justify-end tw-mb-3')
    create-orderable-modal(
      v-if="record.state.name != 'COMPLETED' && record.state.name != 'CANCELED'"
      :data-id='order.id'
      :data-model='order.model'
      :data-maintenance-kinds='dataMaintenanceKinds'
      :data-maintenance-complement-kinds='dataMaintenanceComplementKinds'
      :data-subsidary-hoods='dataSubsidaryHoods'
      :data-orderable-kinds='dataOrderableKinds'
      @created='CreateItem'
    )

  //- Resumen de items
  .tw-flex.tw-items-center.tw-gap-4.tw-mb-3.tw-text-sm(v-if='!emptyItems')
    span.tw-text-gray-600
      i.fa-solid.fa-list-check.tw-text-blue-500.tw-mr-1
      strong {{items.length}}
      |  item(s)
    span.tw-text-green-600.tw-font-medium
      i.fa-solid.fa-dollar-sign.tw-mr-1
      | Total: ${{order.amount_edited}}

  div(v-if='emptyItems')
    .tw-text-center.tw-py-8.tw-text-gray-500
      i.fa-solid.fa-box-open.tw-text-3xl.tw-text-gray-300.tw-mb-2
      p.tw-mt-2 {{$I18n.t('vue.orderables_list_panel.no_order_items')}}
  div(v-else)
    table.table.orderables-styled-table
      thead
        tr
          th.tw-bg-gray-50(colspan="3")
          th.tw-bg-blue-50.tw-text-center(colspan="2")
            i.fa-solid.fa-calculator.tw-mr-1
            | Calculation
          th.tw-bg-green-50.tw-text-center
            i.fa-solid.fa-dollar-sign.tw-mr-1
            | Total
          th.tw-bg-gray-50
        tr.tw-text-xs
          th.tw-text-gray-500.tw-w-10 #
          th
            i.fa-solid.fa-tag.tw-mr-1.tw-text-gray-400
            | {{$I18n.t('vue.orderables_list_panel.table_header_item_kind')}}
          th
            i.fa-solid.fa-wrench.tw-mr-1.tw-text-gray-400
            | {{$I18n.t('vue.orderables_list_panel.table_header_kind')}}
          //- Calculation
          th.tw-bg-blue-50.tw-border-l.tw-text-center
            i.fa-solid.fa-hashtag.tw-mr-1.tw-text-blue-400
            | {{$I18n.t('vue.orderables_list_panel.table_header_quantity')}}
          th.tw-bg-blue-50.tw-border-r.tw-text-center
            i.fa-solid.fa-dollar-sign.tw-mr-1.tw-text-blue-400
            | {{$I18n.t('vue.orderables_list_panel.table_header_price')}}
          //- Total
          th.tw-bg-green-50.tw-border-l.tw-border-r.tw-text-center.tw-font-medium {{$I18n.t('vue.orderables_list_panel.table_header_total')}}
          th.tw-text-center.tw-w-24 Actions
      tbody
        tr(v-for="(item, index) in items" :key="item.id" :class="getRowClass(item)")
          //- Número
          td.tw-text-gray-400.tw-text-xs.tw-text-center {{index + 1}}
          //- Item Kind badge
          td(:class="!item.counts ? 'tw-line-through tw-opacity-50' : ''")
            .tw-flex.tw-items-center.tw-gap-2
              span(
                :class="item.hood == null ? 'tw-bg-cyan-100 tw-text-cyan-700' : 'tw-bg-indigo-100 tw-text-indigo-700'"
                class="tw-px-2 tw-py-1 tw-rounded tw-text-xs tw-font-medium"
              )
                i(:class="item.hood == null ? 'fa-solid fa-plus-circle tw-mr-1' : 'fa-solid fa-cog tw-mr-1'")
                | {{ item.hood==null ? $I18n.t('vue.orderables_list_panel.extra') : $I18n.t('vue.orderables_list_panel.service') }}
              i.fas.fa-info-circle.tw-text-gray-400.tw-text-xs(
                v-if="item.hood == null"
                :title="$I18n.t('vue.orderables_list_panel.extra_items_explanation')"
                style="cursor: help;"
              )
          //- Kind/Name
          td(:class="!item.counts ? 'tw-line-through tw-opacity-50' : ''")
            .tw-flex.tw-items-center
              span.tw-font-medium {{ item.name }}
              span.tw-text-gray-400.tw-text-xs.tw-ml-2(v-if="item.hood") 
                i.fa-solid.fa-fire-burner.tw-mr-1
                | {{ item.hood.equipment_under }}
          //- Quantity
          td.tw-bg-blue-50.tw-bg-opacity-30.tw-border-l.tw-text-center(
            :class="!item.counts ? 'tw-line-through tw-opacity-50' : ''"
          )
            input.tw-w-16.tw-text-center.tw-border.tw-border-gray-300.tw-rounded(
              v-if="record.state.name != 'COMPLETED' && record.state.name != 'CANCELED'"
              type="number"
              v-model="items[index].quantity"
            )
            span.tw-font-medium(v-else) {{ item.quantity }}
          //- Price
          td.tw-bg-blue-50.tw-bg-opacity-30.tw-border-r.tw-text-center(
            :class="!item.counts ? 'tw-line-through tw-opacity-50' : ''"
          )
            .tw-flex.tw-items-center.tw-justify-center.tw-gap-1(v-if="record.state.name != 'COMPLETED' && record.state.name != 'CANCELED'")
              span.tw-text-green-600.tw-font-medium $
              input.tw-w-20.tw-text-center.tw-border.tw-border-green-300.tw-rounded(
                type="number"
                v-model="items[index].price"
                step="0.01"
              )
            span.tw-font-medium.tw-text-green-600(v-else) ${{ item.price }}
          //- Total
          td.tw-bg-green-50.tw-bg-opacity-30.tw-border-l.tw-border-r.tw-text-center(
            :class="!item.counts ? 'tw-line-through tw-opacity-50' : ''"
          )
            span.tw-font-bold.tw-text-green-700(v-if="item.amount != '0.00'") ${{item.amount}}
            span.tw-text-gray-300(v-else) -
          //- Actions
          td.tw-text-center
            .tw-flex.tw-gap-1.tw-justify-center
              app-icon-btn(
                v-if="record.state.name != 'COMPLETED' && record.state.name != 'CANCELED'"
                v-show="enable_button_order_item_save(index)"
                data-kind="link_zoom",
                @click.native="updateItem(items[index], inputs[index])",
                data-icon="fa-solid fa-floppy-disk",
                data-label="Save",
                :data-title="$I18n.t('vue.orderables_list_panel.update_order_item')"
              )
              delete-orderable-modal(
                v-if="record.state.name != 'COMPLETED' && record.state.name != 'CANCELED'"
                :data-id='item.id'
                :data-item='item'
                @deleted='deleteItem'
              )
        //- Total row
        tr.tw-bg-gray-100
          td(colspan="4")
          th.tw-text-right.tw-text-primary.tw-pr-3
            i.fa-solid.fa-calculator.tw-mr-1
            | {{$I18n.t('vue.orderables_list_panel.total_order_price')}}
          td.tw-bg-green-100(
            v-if="record.state.name != 'COMPLETED' && record.state.name != 'CANCELED'"
          )
            .tw-flex.tw-items-center.tw-justify-center.tw-gap-1
              span.tw-font-bold.tw-text-green-600 $
              input.tw-w-24.tw-text-center.tw-border-2.tw-border-green-400.tw-rounded.tw-font-bold.tw-text-lg(
                type="number"
                v-model="order.amount_edited"
                step="0.01"
              )
          td.tw-bg-green-100.tw-text-center(v-else)
            span(class="tw-px-3 tw-py-1 tw-bg-green-500 tw-text-white tw-rounded-full tw-font-bold tw-text-lg") ${{ order.amount_edited }}
          td.tw-text-center
            app-icon-btn(
              v-if="record.state.name != 'COMPLETED' && record.state.name != 'CANCELED'"
              v-show="enable_button_total_order_price_save()"
              data-kind="link_zoom",
              @click.native="updateTotalOrderPrice()",
              data-icon="fa-solid fa-floppy-disk",
              data-label="Save",
              :data-title="$I18n.t('vue.orderables_list_panel.update_total_order_price')"
            )
</template>

<script>
import CoreComponents from "../core";
import { BackendService } from "../../services";
import CreateOrderableModal from './create-orderable-modal.vue';
import DeleteOrderableModal from './delete-orderable-modal.vue'
const { ActiveValue } = require("../../core/active_support");
export default {
  props: {
    dataId: String,
    dataModel: String,
    dataRecord: String,
    dataItems: String,
    dataAmount: String,
    dataItemKinds: String,
    dataMaintenanceKinds: String,
    dataMaintenanceComplementKinds: String,
    dataOrderableKinds: String,
    dataSubsidaryHoods: String,
  },
  components:{
    'create-orderable-modal': CreateOrderableModal,
    'delete-orderable-modal': DeleteOrderableModal,
    "app-icon-btn": CoreComponents.AppIconBtn,
  },
  data: function () {
    this.record = JSON.parse(this.dataRecord);
    return {
      order: {
        id: this.dataId,
        model: this.dataModel,
        amount: (this.dataAmount*100/100).toFixed(2),
        amount_edited: (this.dataAmount*100/100).toFixed(2),
      },
      items: JSON.parse(this.dataItems),
      inputs: JSON.parse(this.dataItems),
      values: {
        item: {
          kind: "",
          price: null,
          quantity: null,
          orderable: {},
          hood: null,
        },
        selected: ActiveValue().setup((i)=>{
        })
      },
      options: {
        orderables: [
          { label: this.$I18n.t('vue.orderables_list_panel.service'), value: "maintenances" },
          { label: this.$I18n.t('vue.orderables_list_panel.extra'),   value: "maintenance_complements" },
        ],
        itemKinds: JSON.parse(this.dataItemKinds)
      },
    };
  },
  methods: {
    getRowClass: function(item) {
      if (!item.counts) return "tw-bg-gray-100 tw-opacity-60";
      return "hover:tw-bg-blue-50";
    },
    enable_button_total_order_price_save: function(){
      let result = 0
      let mount_orig = (this.order.amount*100/100).toFixed(2)
      let mount_edit = (this.order.amount_edited*100/100).toFixed(2)
      if ( mount_orig != mount_edit ){
        result = 1
      }else{
        result = 0
      }
      return result
    },
    updateTotalOrderPrice: function(){
      return BackendService.order_update_total_price(
        JSON.stringify({
          id: this.order.id,
          price: this.order.amount_edited,
        })
      ).then((response) => {
        if (response.isError){
          //Error
        }
        if (response.isOk){
          this.order.amount=response.order.table.price
          this.order.amount_edited=this.order.amount
          location.reload();
        }
      });
    },
    enable_button_order_item_save: function(index){
      let result = 0
      if (this.items[index].price != this.inputs[index].price || this.items[index].quantity != this.inputs[index].quantity){
        result = 1
      }else{
        result = 0
      }
      return result
    },
    updateItem: function (item, input) {
      BackendService.order_update_item(
        JSON.stringify({
          id: item.id,
          counts: item.counts,
          quantity: item.quantity,
          price: item.price,
        })
      ).then((response) => {
        if (response.isError){
          //Error
        }
        if (response.isOk){
          item.price=response.item.table.price
          input.price=item.price
          item.quantity=response.item.table.quantity
          input.quantity=item.quantity
          item.amount=response.item.table.amount
        }
      });
    },
    deleteItem: function (orderable_item) {
      BackendService
        .delete_item_order(orderable_item.id)
        .then((response) => {
          if (response.isOk) {
            let price_item = orderable_item.amount
            this.order.amount_edited = Number(this.order.amount_edited) - Number(price_item)
            this.updateTotalOrderPrice()
            .then((response) => {
              location.reload();
            })
          }
        })
        .catch(() => {
          self.result.isError = true;
          self.result.notice = "error_promise";
          self.state.sending = false;
        });
    },
    CreateItem: function (params) {
      BackendService.create_item_order(params).then(
        (response) => {
          if (response.isOk) {
            let price_new_item=0;
            let quantity_new_item = 0;
            let total_new_item = Number(this.order.amount_edited);
            response.array_created.forEach(element => {
              price_new_item = Number(element.order_item.price)
              quantity_new_item = Number(element.order_item.quantity)
              total_new_item += price_new_item * quantity_new_item
            });
            this.order.amount_edited = total_new_item
            this.updateTotalOrderPrice()
            .then((response) => {
              location.reload();
            })
          }
        }
      );
    },
  },
  computed:{
    emptyItems: function(){
      return this.items.length === 0;
    }
  }
};
</script>

<style scoped>
.orderables-styled-panel {
  padding: 1rem;
}

.orderables-styled-table {
  font-size: 0.85rem;
}

.orderables-styled-table thead th {
  white-space: nowrap;
  vertical-align: middle;
  padding: 0.5rem 0.75rem;
}

.orderables-styled-table tbody td {
  vertical-align: middle;
  padding: 0.5rem 0.6rem;
}

.tw-border-l {
  border-left: 2px solid rgba(0,0,0,0.1) !important;
}

.tw-border-r {
  border-right: 2px solid rgba(0,0,0,0.1) !important;
}

.tw-bg-opacity-30 {
  --tw-bg-opacity: 0.3;
}
</style>